import { EventCallsDto, IPagedCollection, PeriodDto } from '@sr/dto';
import { reportsApi } from '../reports.api';
import { CollectionParams } from 'shared/api/rtk-query';
import { pagingDataToParams } from 'utils/remote-paged-collection.hook';

export type CashBalanceQuery = {
  year: number,
  month: number,
};

const injectedApi = reportsApi.injectEndpoints({
  endpoints: (builder) => ({
    getCallsList: builder.query<IPagedCollection<EventCallsDto>, CollectionParams>({
      query: ({ paging, filter }: CollectionParams) => ({
        url: `calls/all?${filter}`,
        params: paging && pagingDataToParams(paging),
        method: 'GET'
      })
    }),
  })
});

export const callsApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['calls'],
  endpoints: {
    getCallsList: {
      providesTags: ['calls']
    },
  }
});